import { Dispatch, SetStateAction } from 'react';

import dayjs from 'dayjs';

import { activeBar, weekDate, weekDay, weekItem } from './styles.css';

interface WeekItemProps {
  week: {
    date: string;
    isHoliday: number;
  };
  selectedDate: string;
  setSelectedDate: Dispatch<SetStateAction<string>>;
}

export const WeekItem = (props: WeekItemProps) => {
  const { week, selectedDate, setSelectedDate } = props;
  const today = new Date();
  const formattedToday = dayjs(today).format('MM.DD');
  const formattedDate = dayjs(week.date).format('DD');
  const formattedDay = dayjs(week.date).format('dd');

  const isSelectedDate = () => {
    if (!selectedDate) {
      if (formattedDate === formattedToday) {
        return true;
      }
    } else if (selectedDate === week.date) {
      return true;
    }

    return false;
  };

  return (
    <div
      className={weekItem({ active: isSelectedDate() })}
      onClick={() => setSelectedDate(week.date)}
    >
      <div className={weekDay({ active: isSelectedDate() })}>{formattedDay}</div>
      <div className={weekDate({ active: isSelectedDate() })}>{formattedDate}</div>

      {isSelectedDate() && (
        <div
          className={activeBar}
          style={{
            width: 'calc((100vw - 2rem) / 7)',
            height: 3,
          }}
        />
      )}
    </div>
  );
};
